import axios from "axios";
const apiVersion = 1;
const portalId = document.head.querySelector('meta[name="portal-id"]');
const apiBaseUrl = document.head.querySelector('meta[name="api-base-url"]');
const defaultBaseUrl = process.env.KEAZE_API_BASE_URL;

export default axios.create({
    baseURL: apiBaseUrl ? apiBaseUrl.content : defaultBaseUrl,
    headers: {
        'Accept-Version': apiVersion,
        'Content-Type': 'application/json',
        'Portal-Id' : portalId ? portalId.content : process.env.KEAZE_API_TEST_PORTAL
    }
});

export const axiosPrivate = axios.create({
    baseURL: apiBaseUrl ? apiBaseUrl.content : defaultBaseUrl,
    headers: {
        'Accept-Version': apiVersion,
        'Content-Type': 'application/json',
        'Portal-Id' : portalId ? portalId.content : process.env.KEAZE_API_TEST_PORTAL
    }
})
